import Vue from 'vue'
import Vuex from 'vuex'
import { secondsToFullTimestamp, secondsToFormatDateInput, toNumber} from '@/Helper.js' 
import { salesCollection, db, customAuth, processSalesCollection, coleccion_salidas,numeracion_de_documentos } from '../../FirebaseConfig';
Vue.use(Vuex)
export default {
    namespaced:true,
        state: {
            data:{
                items:[]
            },
            loading: true,
            record:{},
            selectedKey:'',
            registerDialog: false,
            annulDialog: false,  
            paso_de_formulario: 1,
        },
        mutations: {
            getAllItems(state, item) {
                Vue.set( state.record, item.id, {...item.data(), key: item.id} )
                state.loading = false
            },
            onLoading : state => state.loading = true,
            offLoading : state => state.loading = false,
        },
        actions: {
            getAll:(context)=>{
                context.state.record = {}
                salesCollection.onSnapshot(data=>data.docs.map( item => context.commit( 'getAllItems', item)))
            },
            lookingForDates:(context)=>{
                context.state.record = []
                salesCollection
                .where('date', '>', new Date(context.state.searchingDate[0]))
                .where('date', '<', new Date(context.state.searchingDate[1]))
                .get().then( data=> data.docs.map( item => context.commit( 'getAllItems', item)) )
            },
            add:async (context)=>{
                context.state.loading = true
                if(context.state.selectedKey=='') {
                    let datos_a_grabar = {
                        ...context.state.data,
                        porcentaje_de_igv: 18.00,
                        total_otros_cargos: 0,
                        percepcion_tipo: "",
                        percepcion_base_imponible: "",
                        total_percepcion: "",
                        total_incluido_percepcion: "",
                        detraccion: false,
                        observaciones: "",
                        documento_que_se_modifica_tipo: "",
                        documento_que_se_modifica_serie: "",
                        documento_que_se_modifica_numero: "",
                        tipo_de_nota_de_credito: "",
                        tipo_de_nota_de_debito: "",
                        enviar_automaticamente_a_la_sunat: true,
                        enviar_automaticamente_al_cliente: false,
                        codigo_unico: "",
                        medio_de_pago: "",
                        placa_vehiculo: "",
                        orden_compra_servicio: "",
                        tabla_personalizada_codigo: "",
                        formato_de_pdf: 'A4',
                        generado_por_contingencia: "",
                        items: context.state.data.items.map(item => ({...item, igv:  toNumber((item.tipo_de_igv === 1) ? 0.18 * Number(item.cantidad) * Number(item.valor_unitario) * (100 - item.descuento )/100 : 0)})),
                        guias: '',    
                        creado_el: new Date,
                        creado_por: customAuth.currentUser.displayName,
                        estado_del_documento: 'esperando',
                    }
                    salesCollection.add(datos_a_grabar).then(()=>{                     
                        context.commit('Helpers/launchSnackbar', '¡Se ha registrado una nueva venta correctamente!', { root: true })
                        context.state.registerDialog = false
                        context.state.loading = false
                    })
                }else{
                    salesCollection.doc(context.state.data.key).update({
                        ...context.state.data, 
                       
                        total_anticipo: 0,
                        total_otros_cargos: 0,
                        updateAt: new Date(), 
                        items: context.state.data.items.map(item => ({...item, igv:  toNumber((item.tipo_de_igv === 1) ? 0.18 * Number(item.cantidad) * Number(item.valor_unitario) * (100 - item.descuento )/100 : 0)})),
                        actualizado_por: customAuth.currentUser.displayName,
                        })
                    context.state.loading = false
                    context.state.registerDialog = false
                    context.dispatch('clearForm')
                    context.commit('Helpers/launchSnackbar', 'Se ha actualizado la venta', { root: true })            
                }
            },
            annul:(context,key)=>{
                salesCollection.doc(key).update({isAnnulled: true, annulledAt: new Date}).then(()=>{
                    context.commit('Helpers/launchSnackbar', 'Se ha anulado el documento', { root: true })
                    context.state.annulDialog = false
                    context.state.registerDialog = false
                })
            },
            get:(context, key)=>{
                salesCollection.doc(key).get().then(doc=>{
                    context.state.data = {
                        ...doc.data(), 
                        key: key, 
                        date: secondsToFormatDateInput(doc.data().date),
                        createdAt: secondsToFullTimestamp(doc.data().createdAt),
                        annulledAt: secondsToFullTimestamp(doc.data().annulledAt),
                    }
                    context.state.selectedKey = key
                    context.state.registerDialog = true
                })
            },
            generar_ventas:async (context,key )=>{

                let numeracion = await numeracion_de_documentos.collection('Nota de salida').doc('00').get()
                let nueva_numeracion = (!numeracion.exists) ? 1 : numeracion.data().numeracion + 1
                let datos = await salesCollection.doc(key).get()
                let warehouse = []
                warehouse.push(datos.data().warehouse)
                coleccion_salidas.add({
                    ...datos.data(),
                    operacion: 'generar_guia',
                    documento_de_operacion:'Nota de salida',
                    numero_de_operacion: nueva_numeracion,
                    motivo_de_traslado:'01',
                    nombre_motivo_de_traslado:'Venta',
                    warehouse: warehouse,
                    estado_del_documento: 'esperando',
                }).then(()=>{
                    numeracion_de_documentos.collection('Nota de salida').doc('00').set({numeracion: nueva_numeracion})
                    context.commit('Helpers/launchSnackbar', 'Se ha generado un nuevo movimiento de salida', { root: true })
                })
                
            },
            closeDocument:(context, key)=>salesCollection.doc(key).update({isClose: true}),

            massiveAdd: async (context, data) => {
                context.state.data.items = await context.dispatch('Product/getKeyByDescription', data,  { root: true })
                context.state.registerDialog = true
                
            },
            clearForm: context => {
                context.state.data= {
                    ...context.state.data,
                    items: [],
                    igv: 0, 
                    client: {},
                    warehouse: null,
                    fecha_de_emision: new Date().toISOString().substr(0, 10),
                    tipo_de_comprobante: false,
                }
                context.state.selectedKey = ''
            },
            openAllDocument: (context) => {
                Object.keys(context.state.record).map(item => salesCollection.doc(item).update( {isClose: false } ).then(()=>context.commit('Helpers/launchSnackbar', 'Se ha abierto las operaciones de venta', { root: true })) )
            },
            process: (context, key) => {
                salesCollection.doc(key).update({estado_del_documento: 'procesando'})
                processSalesCollection.add({key: key})
            },
            unProcess: (context, key) => {
                salesCollection.doc(key).update({estado_del_documento: 'esperando'})
            }

        },
        getters: {
            record: state => Object.keys(state.record).map(item => ({...state.record[item], almacen_de_origen: state.record[item].warehouse.name}) )
            
        }
}
